import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { PatientListDto } from "../patient/patient-api";
import { DiscountPriorityDto } from "../register/discount-priority-dto";
import { ValueTextPair } from "src/app/shared/models/value-text-pair";

@Injectable({
  providedIn: 'root'
})


export class DiscountPriorityApi {
  api: WebApiService;
  apiService: WebApiService;

  constructor(
    private apiClient: WebApiClient) {
    this.api = apiClient.createHisService('payments/discountpriority');
  }
  
  private unsubscribe: Subject<void> = new Subject();


  async GetDiscountPriorityByDate(regDate: Date):Promise< DiscountPriorityDto[]> {
    return await this.api.get(`GetDiscountPriorityByDate`, {regDate:regDate.toLocaleDateString()}).toPromise<DiscountPriorityDto[]>();
  }
  async GetDiscountByDate(regDate: Date):Promise< ValueTextPair[]> {
    return await this.api.get(`GetDiscountByDate`, {regDate:regDate.toLocaleDateString()}).toPromise<ValueTextPair[]>();
  }
}
export { PatientListDto };